exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ColorPicker-container {\n\tposition: relative;\n}\n.open-DColorPicker {\n\twidth: 50px;\n\theight: 50px;\n\tborder-radius: 100%;\n\tcursor: pointer;\n\tposition: relative;\n}\n.vc-chrome , .vc-swatches{\n\tposition: absolute;\n\tright: 0;\n\ttop: 55px;\n\tz-index: 9\n}\nspan.close-icon .icon {\n\theight: 100%;\n\twidth: 100%;\n\tcolor: #ffffff85;\n}\nspan.close-icon {\n\tposition: absolute;\n\tz-index: 1;\n\theight: 100%;\n\twidth: 100%;\n\tfont-size: 48px;\n}\n.ColorPicker-container .delete-btn{\n\tvertical-align: middle;\n}\n\n", ""]);

// exports
